(function () {
    "use strict";

    function authorize(currentUser, $log) {

        var reasons = {
            allowed: 0,
            notLoggedIn: 1
        };

        var canNavigateToState = function (toState) {
            var stateConfig = toState && toState.data;

            if (!stateConfig || stateConfig.authorize === null) {
                return reasons.allowed;
            }

            if (stateConfig.authorize === true && currentUser.profile.loggedIn === false) {
                $log.debug("Not allowed to navigate to " + toState.url);
                return reasons.notLoggedIn;
            } else {
                return reasons.allowed;
            }

        };

        return {
            canNavigateToState: canNavigateToState,
            reasons: reasons
        };
    }

    authorize.$inject = ["sphForms.currentUser", "$log"];

    angular.module("sphForms.auth")
        .factory("sphForms.authorize", authorize);

})();
